import script from "./rcdwlist.vue?vue&type=script&setup=true&lang=js"
export * from "./rcdwlist.vue?vue&type=script&setup=true&lang=js"

import "./rcdwlist.vue?vue&type=style&index=0&id=07725057&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07725057"]])

export default __exports__